/**
 * Calculates loan payment and intermediary numerator and denominator
 * This calculation (or some of it) is used in all four calculators
 *
 * @param {Object} param0 - object with properties for rate, term, and principal
 * @return {[number, number, number]} - array with numerator, denominator, payment
 *
 */
function calculateNumeratorDenominatorPayment({
  rate = 0,
  term = 0,
  principal = 0,
}) {
  const numerator = rate * Math.pow(1 + rate, term);
  const denominator = Math.pow(1 + rate, term) - 1;
  const rawPayment = principal * (numerator / denominator);

  // Limiting to two decimal places
  const payment = parseFloat(rawPayment.toFixed(2));
  console.log(payment);

  return [numerator, denominator, payment];
}

export default calculateNumeratorDenominatorPayment;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/util/calculateNumeratorDenominatorPayment.js